import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { formatPercent } from '../../utils/format-percent.util';
import { ConfidentialValue } from '../../components/ConfidentialValue';

export const CostPage_VariableValue_VariableCost_Fragment = graphql(`
  fragment CostPage_VariableValue_VariableCost_Fragment on VariableCost {
    value
  }
`);

interface Props {
  readonly cost: FragmentType<
    typeof CostPage_VariableValue_VariableCost_Fragment
  >;
}

export const VariableValue = ({ cost: pCost }: Readonly<Props>) => {
  const cost = getFragmentData(
    CostPage_VariableValue_VariableCost_Fragment,
    pCost,
  );

  return cost.value === null ? (
    <ConfidentialValue />
  ) : (
    formatPercent(cost.value)
  );
};
